import { hardwareConductorApi } from "./hardwareConductor";

export const { useSimulateBinScanMutation } = hardwareConductorApi;
